// extracted by mini-css-extract-plugin
export default {"containerAll":"styles_containerAll__HBBQh","camera":"styles_camera__EuYM5","single":"styles_single__axJqH","container":"styles_container__Kikyz","buttons":"styles_buttons__a3GRk"};